<template>
  <el-dialog :title="agent.name"
             :visible="isShowDialog"
             v-loading="isLoading"
             @close="onClosePopupButtonClick()"
             width="600px">
    <el-table
      :data="contactPersonList"
      header-row-class-name="table-header-color"
      style="width: 100%">
      <el-table-column
        width="90px">
        <template slot-scope="scope">
          <el-radio v-model="currentSelectedId" :label="scope.row.id"> &nbsp; </el-radio>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('contactPerson')">
        <template  slot-scope="scope">
          <span v-if="scope.row.id === oldSelectedId">{{getContactPersonName(agent.contactPerson)}}</span>
          <span v-else>{{getContactPersonName(scope.row)}}</span>
          <div class="contract-data-version" style="margin: 0"
               v-if="isUpdatedData(contactPersonListOriginal, oldSelectedContactPerson) && scope.row.id === oldSelectedId && currentSelectedId === scope.row.id">
            <div class="contract-data-updated">
              <div style="padding: 20px 0 0 20px">
                <strong>*{{$t('updatedContactPersonMessage')}}</strong>
              </div>
              <el-radio-group style="padding-left: 40px" v-model="version" fill="#ff0000">
                <div class="contract-data-version-radio">
                  <el-radio :label="DATA_VERSION.SELECTED">{{$t('selectedVersion')}} ({{bindUpdatedAt(oldSelectedContactPerson.updatedAt)}})</el-radio>
                </div>
                <div class="contract-data-version-radio">
                  <el-radio :label="DATA_VERSION.LATEST">{{$t('latestVersion')}} ({{bindUpdatedAt(scope.row.updatedAt)}})</el-radio>
                </div>
              </el-radio-group>
            </div>
          </div>
          <div class="contract-data-version" style="margin: 0"
               v-if="isDeletedData(contactPersonListOriginal, scope.row.id) && scope.row.id === oldSelectedId && currentSelectedId === scope.row.id">
            <div class="contract-data-deleted">
              <div style="padding: 20px 0 0 20px">
                <strong style="color: #dd3333">*{{$t('deletedContactPersonMessage')}}</strong>
              </div>
              <el-radio-group style="padding-left: 40px" v-model="scope.row.id" fill="#ff0000" >
                <el-radio :label="scope.row.id" class="contract-data-version-radio">{{$t('selectedVersion')}} ({{bindUpdatedAt(scope.row.updatedAt)}})</el-radio>
              </el-radio-group>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="onSaveButtonClick">{{ $t('save') }}</el-button>
      <el-button type="default" @click="onCancelButtonClick">{{ $t('cancel') }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import AlertViewMixin from '@/mixins/alert-view-mixin'
import i18nMessages from '@/translations/SpecialOffer/components/PopupManageContactPersonComponent.i18n'
import AgentContactPersonApi from '@/api/agent/contact-person-api'
import { get } from 'lodash'
import { dateFormat } from '@/helpers/datetime'
import { isUpdatedData, isDeletedData, DATA_VERSION } from '@/services/version-service'

export default {
  name: 'PopupManageContactPersonComponent',
  mixins: [AlertViewMixin],
  i18n: { messages: i18nMessages },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    agent: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  watch: {
    visible: function (newValue) {
      this.isShowDialog = newValue

      if (this.isShowDialog) {
        this.currentSelectedId = get(this.agent, 'contactPerson.id', '')
        this.oldSelectedId = get(this.agent, 'contactPerson.id', '')
        this.oldSelectedContactPerson = get(this.agent, 'contactPerson', {})
        this._getContactPersonList()
      }
    }
  },
  data () {
    return {
      isUpdatedData,
      isDeletedData,
      DATA_VERSION,
      isShowDialog: false,
      contactPersonList: [],
      contactPersonListOriginal: [],
      isLoading: false,
      currentSelectedId: '',
      oldSelectedId: '',
      oldSelectedContactPerson: {},
      version: DATA_VERSION.SELECTED
    }
  },
  methods: {
    getContactPersonName: function (contactPerson) {
      if (!contactPerson) {
        return ''
      }
      const title = get(contactPerson, 'title', '')
      const firstName = get(contactPerson, 'firstName', '')
      const lastName = get(contactPerson, 'lastName', '')

      return `${title}${firstName} ${lastName}`
    },
    _getContactPersonList: async function () {
      this.isLoading = true

      try {
        this.contactPersonListOriginal = await AgentContactPersonApi.list(this.agent.id)
        this.contactPersonList = [...this.contactPersonListOriginal]

        if (this.oldSelectedId !== '') {
          if (isDeletedData(this.contactPersonListOriginal, this.oldSelectedId)) {
            this.contactPersonList.push(this.oldSelectedContactPerson)
          }
        }
      } catch (err) {
        this.alertError(err.message)
      }

      this.isLoading = false
    },
    onCancelButtonClick: function () {
      this._closePopup()
    },
    onClosePopupButtonClick: function () {
      this._closePopup()
    },
    bindUpdatedAt: function (updatedDate) {
      const date = new Date(updatedDate)
      return dateFormat.long(date)
    },
    onSaveButtonClick: function () {
      this.isLoading = false
      let contactPerson = this._getNewContactPerson()
      if (this.currentSelectedId === this.oldSelectedId && this.currentSelectedId !== '') {
        if (this.version === DATA_VERSION.SELECTED) {
          contactPerson = this.oldSelectedContactPerson
        }
      }
      this.contactPersonList = []
      this.$emit('onSave', contactPerson)
    },
    _getNewContactPerson: function () {
      const contactPerson = this.contactPersonList.find(item => item.id === this.currentSelectedId)
      return contactPerson
    },
    _closePopup: function () {
      this.contactPersonList = []
      this.isLoading = false
      this.$emit('onClose')
    }
  }
}
</script>
